import http from "@http"

//积分管理接口地址
let API = {
    //获取近一个月充电人数和次数
    DAY_URL : "/report/dayChargeCount",
    //获取近一年充电人数和次数
    MONTH_URL :"/report/monthChargeCount",
    //获取总的充电信息
    INFO_URL: "/report/chargeInfo",
    //充电次数异常预警
    RISK_INFO_URL: "/report/hchargeInfoRisk",
}


//获取近一个月充电人数和次数
export function getDayCharge(){
    return http.post(API.DAY_URL)
}

//获取近一年充电人数和次数
export function getMonthCharge(){
    return http.post(API.MONTH_URL)
}

//获取总的充电信息
export function getChargeInfo(){
    return http.post(API.INFO_URL)
} 
//获取总的充电信息
export function chargeRiskInfo(){
    return http.post(API.RISK_INFO_URL)
} 

